import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import pg2 from "../assets/pg2.mp3"

const Page2 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { round } = rond;
  const allResults = location.state.allResults;
  console.log("round in pg2", round);
  console.log("allResults in pg2", allResults);
  round = round - 1;
  let roundc = round / 4;


  const initialPos = { x: 27, y: -30, opacity: 0.5 };
  const animatePos = { x: 0, y: 0, opacity: 1 };

  const toggleMute = () => {
    const audio = document.getElementById('audio');
    audio.muted = !audio.muted;
  };

  return (
    <>
      <div class="fixed top-16 right-10 h-4/5 w-1/5 rounded-xl bg-emerald-100 shadow p-4">
        <div class="text-center">
          <h2 className="text-xl pb-10 pt-4 font-semibold">Calculating w{round+4}</h2>
          <p class="text-sm">
            Now we start working on Calculating the next word which is performed using a function g on the last word found.
            <br />
            <br />
            Here we can see what this function g actually is.{" "}
            <br />
            <br />
            The first step in Calculating g of a word is to perform a circular left shift on the word.
          </p>

          <audio id="audio" controls className="mt-4 w-full">
            <source src={pg2} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <button
            onClick={toggleMute}
            className="mt-2 bg-gray-300 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded"
          >
            Mute
          </button>
        </div>
      </div>

      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <p className="text-xl pt-3">Round {roundc + 1}</p>
          </div>
          <div className="pt-10">
            <h1>Hex Value: {allResults[4]}</h1>
            <br />
          </div>

          <div className="flex flex-col">
            <table className="border-separate border-spacing-2 border border-slate-500 ...">
              <tr>
                <th>w{round}</th>
                <th>w{round + 1}</th>
                <th>w{round + 2}</th>
                <th>w{round + 3}</th>
              </tr>

              <tr>
                <td>{allResults[3][round][0]}</td>
                <td>{allResults[3][round + 1][0]}</td>
                <td>{allResults[3][round + 2][0]}</td>
                <td>{allResults[3][round + 3][0]}</td>
              </tr>
              <tr>
                <td>{allResults[3][round][1]}</td>
                <td>{allResults[3][round + 1][1]}</td>
                <td>{allResults[3][round + 2][1]}</td>
                <td>{allResults[3][round + 3][1]}</td>
              </tr>
              <tr>
                <td>{allResults[3][round][2]}</td>
                <td>{allResults[3][round + 1][2]}</td>
                <td>{allResults[3][round + 2][2]}</td>
                <td>{allResults[3][round + 3][2]}</td>
              </tr>
              <tr>
                <td>{allResults[3][round][3]}</td>
                <td>{allResults[3][round + 1][3]}</td>
                <td>{allResults[3][round + 2][3]}</td>
                <td>{allResults[3][round + 3][3]}</td>
              </tr>
            </table>
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1.5 }}
            >
              <h2 className="text-xl mt-3 bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out">
                w{round + 4} = w{round} xor g(w{round + 3})
              </h2>
            </motion.div>
          </div>

          <motion.div
            className="bg-emerald-100 mt-5 p-6 rounded-lg shadow-lg hover:shadow-xl leading-8"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 3.5 }}
          >
            <h1 className="text-2xl font-semibold pb-3">
              What is the function g?
            </h1>
            Step 1: Rotate w{round + 3} (circular left shift)
            <br></br>
            Before Rotation: {allResults[3][round + 3][0]}{" "}
            {allResults[3][round + 3][1]} {allResults[3][round + 3][2]}{" "}
            {allResults[3][round + 3][3]}
            <br></br>
            After Rotation:
            <motion.span
              initial={initialPos}
              animate={animatePos}
              transition={{ delay: 4 }}
              style={{
                display: "inline-block",
                color: "blue", // Change color or other style properties as needed
              }}
            >
              {allResults[0][roundc][0]}
            </motion.span>{" "}
            <motion.span
              initial={initialPos}
              animate={animatePos}
              transition={{ delay: 4 }}
              style={{
                display: "inline-block",
                color: "blue", // Change color or other style properties as needed
              }}
            >
              {allResults[0][roundc][1]}
            </motion.span>{" "}
            <motion.span
              initial={initialPos}
              animate={animatePos}
              transition={{ delay: 4 }}
              style={{
                display: "inline-block",
                color: "blue", // Change color or other style properties as needed
              }}
            >
              {allResults[0][roundc][2]}
            </motion.span>{" "}
            <motion.span
              initial={{ x: -60, y: -30, opacity: 0.5 }}
              animate={animatePos}
              transition={{ delay: 4.5 }}
              style={{
                display: "inline-block",
                color: "green", // Change color or other style properties as needed
              }}
            >
              {allResults[0][roundc][3]}
            </motion.span>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Page2;
